import * as React from "react";
import { Alert } from "react-bootstrap";

type Error =
	| {
			message: string;
			index: number;
	  }
	| string;

interface Props {
	errorMessage: Error[] | Error;
}

const ErrorAlert = ({ errorMessage }: Props) => {
	const getMessage = (error: Error): string => (typeof error === "string" ? error : error?.message);

	if (!errorMessage) {
		return null;
	}

	return (
		// TODO: Setting eslint for FRAGMENT!!!
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{Array.isArray(errorMessage) ? (
				errorMessage.map((error) => (
					// @ts-ignore
					<Alert bsStyle="danger" key={getMessage(error)}>
						{getMessage(error)}
					</Alert>
				))
			) : (// @ts-ignore
				<Alert bsStyle="danger">{getMessage(errorMessage)}</Alert>
			)}
		</>
	);
};

export default ErrorAlert;
